import { AUTH_PREFIX } from '@/config/api'
import auth from '@/helpers/auth'
import type { ResetPwdModel } from '@/types/models/ResetPwdModel'
import type { UserDataModel, UserModel } from '@/types/models/UserModel'
import type { AxiosResponse } from 'axios'
import type { TwoFaLoginModel, TwoFaVerifyModel } from '../types/models/TwoFaModel'
import TokenService from './token.service'

export const TWOFA_AUTH_PREFIX = `${AUTH_PREFIX}/2fa`

const authApi = {
    login: (user: any) =>
        auth
            .post('/login', user)
            .then((response: AxiosResponse<UserDataModel | TwoFaLoginModel>) => {
                if (response.status !== 200) {
                    if (response.status === 401) {
                        location.reload()
                        return undefined
                    }
                }
                if ((response.data as TwoFaLoginModel)?.requires_2fa) return response.data
                TokenService.setUser(response.data as UserDataModel)
                return response.data as UserDataModel
            }),

    me: (): Promise<UserModel> =>
        auth
            .post('/me')
            .then(response => response.data)
            .catch(error => Promise.reject(error)),

    logout: () => TokenService.removeUser(),

    sendResetLink: (email: string) =>
        auth
            .post(`${AUTH_PREFIX}/email`, { email })
            .then(response => response)
            .catch(error => Promise.reject(error)),

    resetPassword: (reset: ResetPwdModel) =>
        auth
            .post(`${AUTH_PREFIX}/reset`, reset)
            .then(response => response)
            .catch(error => Promise.reject(error)),

    enable2fa: () =>
        auth
            .post(`${TWOFA_AUTH_PREFIX}/enable`)
            .then(response => response)
            .catch(error => Promise.reject(error)),

    disable2fa: () =>
        auth
            .post(`${TWOFA_AUTH_PREFIX}/disable`)
            .then(response => response)
            .catch(error => Promise.reject(error)),
    confirm2fa: (code: string) =>
        auth
            .post(`${TWOFA_AUTH_PREFIX}/confirm`, { code })
            .then(response => response)
            .catch(error => Promise.reject(error)),
    verify2fa: (data: TwoFaVerifyModel): Promise<UserDataModel | undefined> =>
        auth
            .post(`${TWOFA_AUTH_PREFIX}/verify`, data)
            .then(response => {
                if (response.status !== 200) {
                    if (response.status === 401) {
                        location.reload()
                        return undefined
                    }
                }
                TokenService.setUser(response.data as UserDataModel)
                return response.data as UserDataModel
            })
            .catch(error => Promise.reject(error))
}

export default authApi
